import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Autocomplete } from "@mui/lab";
import { Chip, Grid, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RegularButton from "../../components/CustomButtons/Button";
import { dateValidator } from "../../helpers/dateValidator";
import { formatCustomDate, newDate } from "../../helpers/dateTools";
import { useSearch } from "../../hooks/useSearch";
import {
  handleInvoicesInputs,
  getInvoices,
} from "../../redux/actions/invoices/invoicesAction";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const InvoicesInputs = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { stationsList } = useSelector(({ companies }) => companies);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, stations } = useSelector(
    ({ invoices }) => invoices,
  );
  const currentDate = formatCustomDate(new Date(), "-");

  const handleStartDate = ({ target }) => {
    dispatch(handleInvoicesInputs("startDate", target.value));
  };

  const handleEndDate = ({ target }) => {
    dispatch(handleInvoicesInputs("endDate", target.value));
  };

  const handleChange = (_e, v) => {
    const value = v || [];
    dispatch(handleInvoicesInputs("stations", value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (stations.length === 0) {
      setSnackbar("Seleccione una planta", "warning");
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getInvoices(startDate, endDate, stations));
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        padding: 4,
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={2} style={style}>
          <TextField
            label="Desde"
            type="date"
            name="startDate"
            value={startDate}
            variant="outlined"
            fullWidth
            required={true}
            onChange={handleStartDate}
            size="small"
            inputProps={{
              max: currentDate,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={2} style={style}>
          <TextField
            label="Hasta"
            type="date"
            name="endDate"
            value={endDate}
            variant="outlined"
            fullWidth
            onChange={handleEndDate}
            size="small"
            inputProps={{
              max: newDate({
                diffDays: 1,
              }),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={7} style={style}>
          <Autocomplete
            id="combo-box-demo"
            options={stationsList}
            value={stations}
            limitTags={3}
            getOptionLabel={(option) =>
              option.label ? option.label : option.name
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={index}
                  variant="outlined"
                  label={option?.name ? option.name : option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                name="stations"
                label="Planta"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={handleChange}
            noOptionsText="No se encuentra la planta"
            closeIcon={
              <CloseIcon
                fontSize="small"
                style={{
                  marginRight: 24,
                }}
              />
            }
            multiple
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={1}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RegularButton
            color="info"
            onClick={handleSubmit}
            fullWidth
            loading={isLoadingComp?.invoicesLoading}
          >
            buscar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
